import { useCallback, useEffect, useRef, useState } from 'react';

// owns the open state and the click-away / escape dismissal of one row's move-to-table menu
const useLifecareStudioRowMoveMenu = ({ onSelectTarget }) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef(null);

  const closeMenu = useCallback(() => setIsOpen(false), []);

  const toggleMenu = useCallback(() => setIsOpen((prev) => !prev), []);

  const selectTarget = useCallback(
    ({ targetSubsectionIndex }) => {
      setIsOpen(false);
      onSelectTarget({ targetSubsectionIndex });
    },
    [onSelectTarget]
  );

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (anchorRef.current && !anchorRef.current.contains(event.target)) closeMenu();
    };
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') closeMenu();
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, closeMenu]);

  return { isOpen, anchorRef, toggleMenu, closeMenu, selectTarget };
};

export default useLifecareStudioRowMoveMenu;
